// import { ROUTES } from 'routes/constants';
import { ClientsView } from 'features/new-clients/components/clients-details/clients-view';
import { useParams } from 'react-router-dom';
export const ClientsDetailsView = () => {
  // const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  // const navigateToList = () => {
  //   navigate(ROUTES.CLIENTS);
  // };

  return <ClientsView />;
};
